import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';


const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const ChangePasswordForm = ({ userEmail }) => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordError, setPasswordError] = useState(false);
    const [confirmPasswordError, setConfirmPasswordError] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);


    const handleCurrentPasswordChange = (value) => {
        setCurrentPassword(value);
    };

    const handleNewPasswordChange = (value) => {
        setNewPassword(value);
    };

    const handleConfirmPasswordChange = (value) => {
        setConfirmPassword(value);
    };

    const handlePasswordChangeProcess = () => {
        setSuccessMessage('');
        setErrorMessage('');

        const hasLengthError = newPassword.length < 6;
        const hasMismatchError = confirmPassword !== newPassword;
        setPasswordError(hasLengthError);
        setConfirmPasswordError(hasMismatchError);
        if (hasLengthError || hasMismatchError) {
            return;
        }

        const changePasswordData = {
            CurrentPassword: currentPassword,
            NewPassword: newPassword,
            ConfirmPassword: confirmPassword,
            Email: userEmail,
        };

        setIsSubmitting(true);
        axios
            .post(`${BASE_URL}api/UserAccount/ChangePassword`, changePasswordData)
            .then((result) => {
                setIsSubmitting(false);
                if (typeof result.data === 'string' && result.data.toLowerCase().includes('successfully')) {
                    setSuccessMessage(result.data);
                    setCurrentPassword('');
                    setNewPassword('');
                    setConfirmPassword('');
                } else {
                    setErrorMessage(result.data);
                }
            })
            .catch(() => {
                setIsSubmitting(false);
                setErrorMessage('Could not reach the server. Please try again.');
            });
    };

    return (
        <div className="auth-form d-flex align-items-center justify-content-center" style={{ marginTop: '2rem' }}>
            <div className="col-md-6" style={{ maxWidth: '450px', maxHeight: '960px' }}>
                <div className="card border-0 shadow">
                    <div className="card-header bg-primary text-white text-center">
                        <h3>Change Password</h3>
                    </div>
                    <div className="card-body">
                        <div className="mb-3">
                            <label htmlFor="currentPassword" className="form-label">
                                Current Password
                            </label>
                            <input
                                type="password"
                                className="form-control"
                                id="currentPassword"
                                placeholder="Enter current password"
                                value={currentPassword}
                                onChange={(e) => handleCurrentPasswordChange(e.target.value)}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="newPassword" className="form-label">
                                New Password
                            </label>
                            <input
                                type="password"
                                className={`form-control ${passwordError ? 'is-invalid' : ''}`}
                                id="newPassword"
                                placeholder="Enter new password"
                                value={newPassword}
                                onChange={(e) => handleNewPasswordChange(e.target.value)}
                                required
                            />
                            {passwordError && (
                                <div className="invalid-feedback">Password should be at least 6 characters.</div>
                            )}
                        </div>
                        <div className="mb-3">
                            <label htmlFor="confirmPassword" className="form-label">
                                Confirm Password
                            </label>
                            <input
                                type="password"
                                className={`form-control ${confirmPasswordError ? 'is-invalid' : ''}`}
                                id="confirmPassword"
                                placeholder="Confirm new password"
                                value={confirmPassword}
                                onChange={(e) => handleConfirmPasswordChange(e.target.value)}
                                required
                            />
                            {confirmPasswordError && (
                                <div className="invalid-feedback">Passwords do not match.</div>
                            )}
                        </div>
                        {successMessage && (
                            <div className="alert alert-success" role="alert">{successMessage}</div>
                        )}
                        {errorMessage && (
                            <div className="alert alert-danger" role="alert">{errorMessage}</div>
                        )}
                        <div className="d-grid gap-2">
                            <button
                                className="btn btn-primary btn-lg"
                                type="submit"
                                onClick={() => handlePasswordChangeProcess()}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'Changing…' : 'Change Password'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};


